import React, { useState, useEffect } from 'react'
import {
  Box, Typography, Button, Grid, CircularProgress
} from '@mui/material'
import RecruiterCard from './RecruiterCard'
import AddRecruiterCard from './AddRecruiterCard'
import RecruiterModal from './RecruiterModal'
import { fetchRecruiterList, addRecruiter } from '../../api/recruiterApi'
import { addTools } from '../../api/toolsApi'
import ValidationErrorText from '../common/ValidationErrorText'

const initialAddFields = { name: '', logo: '', uploading: false, uploadProgress: 0, error: '', }

const TopRecruiters = ({
  label,
  value = [],
  readOnly = false,
  onChange,
  fetchList,
  fieldErrors,fieldError,fieldType
}) => {
  const [allRecruiters, setAllRecruiters] = useState([])
  const [loading, setLoading] = useState(true)
  const [showAddForm, setShowAddForm] = useState(false)
  const [addFields, setAddFields] = useState(initialAddFields)
  const [modalOpen, setModalOpen] = useState(false)
  const [saving, setSaving] = useState(false)
  const [items, setAllItems] = useState([])

  useEffect(() => {
    setLoading(true)
    fetchList()
      .then((items) => setAllItems(items || []))
      .finally(() => setLoading(false))
  }, [fetchList])

  const handleAddRecruiter = async () => {
    if (!addFields.name || !addFields.logo) return
    setSaving(true)
    try {
      let newRecruiter;
      if(label.includes('Tools')) {
        newRecruiter = await addTools({ name: addFields.name, image: addFields.logo })
      }else {
        newRecruiter = await addRecruiter({ name: addFields.name, image: addFields.logo })
      }
      setAllRecruiters(prev => [...prev, newRecruiter])
      onChange([...(value || []), newRecruiter])
      setAddFields(initialAddFields)
      setShowAddForm(false)
    } catch (error) {
      setAddFields(fields => ({
        ...fields,
        error: error?.response?.data?.message || 'Failed to add recruiter'
      }))
    }
    setSaving(false)
  }

  const handleDeleteAddRecruiter = () => {
    setAddFields(initialAddFields)
    setShowAddForm(false)
  }

  const handleEditRecruiterName = (index, newName) => {
    const updated = value.map((r, i) =>
      i === index ? { ...r, name: newName } : r
    )
    onChange(updated)
  }

  const handleRemoveRecruiter = (index) => {
    onChange(value.filter((_, i) => i !== index))
  }

  if (loading) return <CircularProgress size={28} sx={{ mt: 2 }} />

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
        <Box>
        <Typography sx={{ fontSize: '16px', fontWeight: '500' }} fontWeight={600}>{label}</Typography>
        <ValidationErrorText error={fieldError}/>
        </Box>
        {!readOnly && (
          <Button
            variant="outlined"
            sx={{ mt: 2, textTransform: 'capitalize' }}
            onClick={() => setModalOpen(true)}
          >
            Select {label}
          </Button>
        )}
      </Box>

      <Grid container spacing={2} mt={2}>
        {(value || []).map((r, index) => (
          <Grid item xs={12} sm={6} md={6} lg={6} xl={4} key={r._id || index}>
            <RecruiterCard
              name={r.name}
              logo={r.image || r.logo}
              onRemove={readOnly ? undefined : () => handleRemoveRecruiter(index)}
              onEditName={readOnly ? undefined : (newName) => handleEditRecruiterName(index, newName)}
            />
            <ValidationErrorText error={fieldErrors?.[`${fieldType}[${index}.value]`]}/>
          </Grid>
        ))}

        {/* Add New card */}
        {!readOnly && (
          <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
            <AddRecruiterCard
              showForm={showAddForm}
              onShowForm={setShowAddForm}
              name={addFields.name}
              logo={addFields.logo}
              uploading={addFields.uploading}
              uploadProgress={addFields.uploadProgress}
              error={addFields.error}
              onFieldChange={(field, val) =>
                setAddFields(fields => ({ ...fields, [field]: val }))
              }
              onSave={handleAddRecruiter}
              onDelete={handleDeleteAddRecruiter}
              saving={saving}
            />
          </Grid>
        )}
      </Grid>

      <RecruiterModal
        label={label}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        allRecruiters={allRecruiters}
        selected={value}
        onSave={arr => {
          onChange(arr)
          setModalOpen(false)
        }}
        allItems={items}
        setAllItems={setAllItems}
      />
    </Box>
  )
}

export default TopRecruiters
